import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import * as fromAddCardSelector from '../../../features/payment-runs/selectors';
import { Store } from '@ngrx/store';
import { fromEvent, Subscription } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as actions from '../../../features/payment-mandate/actions';
import { ICheckCardStatusRequest } from 'src/app/features/add-credit-card/models/check-card-status.model';
import { HelpersService } from 'src/app/core/services/helpers.service';
import * as paymentMandateSelector from '../../../features/payment-mandate/selectors';
import { skip } from 'rxjs/operators';
import { APP_CONFIG } from 'src/app/config/app-config.module';
import { AppConfig } from 'src/app/core/config-models/app-config.model';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit, OnDestroy {
  subscription: Subscription = new Subscription();
  @ViewChild('myIframe', { static: true }) myIframe: ElementRef;
  display: boolean;
  viewPort: string;
  sanitizedViewPort: SafeResourceUrl;
  checkCardStatusRequest: ICheckCardStatusRequest;
  index = 0;

  constructor(
    private store: Store,
    private sanitizer: DomSanitizer,
    private helperService: HelpersService,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.store.select(paymentMandateSelector.getIsPaymentMandateAccepted).subscribe(isAccepted => {
        if (isAccepted) {
          this.display = true;
        } else {
          this.display = false;
        }
      })
    );

    this.subscription.add(
      this.store.select(fromAddCardSelector.fromAddCreditCard.selectAddCreditCardResponse).subscribe(data => {
        if (data !== undefined) {
          if (data.redirectUrl !== null) {
            this.checkCardStatusRequest = {
              peachPaymentTransactionId: data.peachPaymentTransactionId
            };

            this.viewPort = `
          <!DOCTYPE html>
            <html>
              <head>
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
              </head>
              <body style="flex:1;flex-direction:column;justify-content:flex-start;align-items:center;text-align:center;">
                  <div style="margin-top:87px;text-align:center;font-size:14px;">
                    We're handing you over to your bank now!
                  </div>
                <script>
                  setTimeout(()=>{ document.threefac.submit() },2000);
                </script>
                <form style="visibility:hidden;" action=${data.redirectUrl} name="threefac" method="POST">
                  <input style="visibility:hidden;" type="text" name="threeDSMethodData" value=${data.threeDSMethodData} />
                  <input type="submit" style="visibility:hidden;" value="submit" />
                </form>
              </body>
            </html>
          `;
            this.sanitizedViewPort = this.sanitizer.bypassSecurityTrustHtml(this.viewPort);
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription.remove;
  }

  hideDialog() {
    this.display = false;
  }

  changeDetected(event) {
    if (this.appConfig.env === 'stg' || this.appConfig.env === 'prod') {
      this.index++;
      this.subscription.add(
        fromEvent(this.myIframe.nativeElement, 'load')
          .pipe(skip(1)) //skip first and second call as the iframe gets mounted
          .subscribe(() => {
            if (this.index > 5) {
              // make sure dispatch doesn't happen more than once
              this.index = 0;
              this.store.dispatch(
                actions.loadCheckCardStatus({
                  businessId: this.helperService.checkBusinessIdState(undefined),
                  request: this.checkCardStatusRequest
                })
              );
            }
          })
      );
    } else {
      this.index++;
      this.subscription.add(
        fromEvent(this.myIframe.nativeElement, 'load')
          .pipe(skip(2)) //skip first and second call as the iframe gets mounted
          .subscribe(() => {
            if (this.index > 5) {
              // make sure dispatch doesn't happen more than once
              this.index = 0;
              this.store.dispatch(
                actions.loadCheckCardStatus({
                  businessId: this.helperService.checkBusinessIdState(undefined),
                  request: this.checkCardStatusRequest
                })
              );
            }
          })
      );
    }
  }
}
